import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Percent, X } from 'lucide-react';
import { toast } from 'sonner';

// Discount sheet (iter378) — quick percent/amount entry with
// preset chips. Writes to `discount` and `discountType` already
// consumed by the existing totals math.
export const PosDiscountSheet = ({
  open,
  discount,
  setDiscount,
  discountType,
  setDiscountType,
  currencySymbol,
  onClose,
}) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="pos-discount-overlay"
    >
      <div className="bg-white dark:bg-stone-900 rounded-2xl p-5 w-full max-w-md shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
              <Percent size={18} className="text-emerald-700 dark:text-emerald-300" />
            </div>
            <h3 className="font-bold text-base">Apply Discount</h3>
          </div>
          <Button size="icon" variant="ghost" className="h-10 w-10 rounded-lg" onClick={onClose}><X size={16} /></Button>
        </div>
        <div className="grid grid-cols-2 gap-2 mb-3">
          <button
            onClick={() => setDiscountType('percent')}
            className={`py-2.5 rounded-xl font-semibold text-sm transition-all ${discountType === 'percent' ? 'bg-emerald-500 text-white shadow-md' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`}
            data-testid="discount-type-percent"
          >% Percent</button>
          <button
            onClick={() => setDiscountType('amount')}
            className={`py-2.5 rounded-xl font-semibold text-sm transition-all ${discountType === 'amount' ? 'bg-emerald-500 text-white shadow-md' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`}
            data-testid="discount-type-amount"
          >{currencySymbol} Amount</button>
        </div>
        <Input
          type="number"
          value={discount || ''}
          onChange={(e) => {
            const v = Math.max(0, parseFloat(e.target.value) || 0);
            setDiscount(discountType === 'percent' ? Math.min(100, v) : v);
          }}
          placeholder={discountType === 'percent' ? 'e.g. 10' : `e.g. 5.00 ${currencySymbol}`}
          className="h-12 text-lg rounded-xl border-border text-center"
          data-testid="pos-discount-input"
        />
        {discountType === 'percent' && (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mt-3">
            {[5, 10, 15, 20].map((p) => (
              <button
                key={p}
                onClick={() => setDiscount(p)}
                className="py-2 rounded-xl bg-emerald-50 hover:bg-emerald-100 dark:bg-emerald-950/30 dark:hover:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 text-sm font-bold"
                data-testid={`discount-preset-${p}`}
              >{p}%</button>
            ))}
          </div>
        )}
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" className="rounded-xl" onClick={() => setDiscount(0)}>Clear</Button>
          <Button
            className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl"
            onClick={() => {
              onClose();
              toast.success(`Discount applied: ${discountType === 'percent' ? discount + '%' : currencySymbol + ' ' + discount}`);
            }}
            data-testid="pos-discount-apply"
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PosDiscountSheet;
